import { CREATE_STOCK_OPNAME } from "../../constants/admin/masterdata/constants";

const initialState = {
  loading: false,
  success: false,
  error: null,
  data: null,

  loadingSaveDraft: false,
  saveDraftSuccess: false,
  saveDraftError: null,
  saveDraftData: null,

  loadingRelease: false,
  releaseSuccess: false,
  releaseError: null,
  releaseData: null,
};

const createStockOpnameReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_STOCK_OPNAME.LOADING_CREATE_STOCK_OPNAME:
      return {
        ...state,
        loading: action.load,
      };

    case CREATE_STOCK_OPNAME.CREATE_STOCK_OPNAME_SUCCESS:
      return {
        ...state,
        success: true,
        loading: false,
        data: action.data,
        error: null,
      };

    case CREATE_STOCK_OPNAME.CREATE_STOCK_OPNAME_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
        success: false,
      };

    case CREATE_STOCK_OPNAME.CLEAR_CREATE_STOCK_OPNAME:
      return {
        ...state,
        success: false,
        error: null,
      };

    case CREATE_STOCK_OPNAME.LOADING_SAVE_DRAFT_STOCK_OPNAME:
      return {
        ...state,
        loadingSaveDraft: action.load,
      };

    case CREATE_STOCK_OPNAME.SAVE_DRAFT_STOCK_OPNAME_SUCCESS:
      return {
        ...state,
        saveDraftSuccess: true,
        loadingSaveDraft: false,
        saveDraftData: action.data,
        saveDraftError: null,
      };

    case CREATE_STOCK_OPNAME.SAVE_DRAFT_STOCK_OPNAME_ERROR:
      return {
        ...state,
        saveDraftError: action.error,
        loadingSaveDraft: false,
        saveDraftSuccess: false,
      };

    case CREATE_STOCK_OPNAME.CLEAR_SAVE_DRAFT_STOCK_OPNAME:
      return {
        ...state,
        saveDraftSuccess: false,
        saveDraftError: null,
      };

    case CREATE_STOCK_OPNAME.LOADING_RELEASE_STOCK_OPNAME:
      return {
        ...state,
        loadingRelease: action.load,
      };

    case CREATE_STOCK_OPNAME.RELEASE_STOCK_OPNAME_SUCCESS:
      return {
        ...state,
        releaseSuccess: true,
        loadingRelease: false,
        releaseData: action.data,
        releaseError: null,
      };

    case CREATE_STOCK_OPNAME.RELEASE_STOCK_OPNAME_ERROR:
      return {
        ...state,
        releaseError: action.error,
        loadingRelease: false,
        releaseSuccess: false,
      };

    case CREATE_STOCK_OPNAME.CLEAR_RELEASE_STOCK_OPNAME:
      return {
        ...state,
        releaseSuccess: false,
        releaseError: null,
      };

    default:
      return state;
  }
};

export default createStockOpnameReducer;
